import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { subGameListSetting } from "../../../enumerations/gameEnum";
import queryKey from "../../../enumerations/queryKey";
import { apiGetBetRecord, apiGetGameList, apiGetSubGameList } from "../service";

export const useGetBetRecord = ({ options, params }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.BET_INQUIRY, ..._arrParams],
    ({ pageParam = 1 }) =>
      apiGetBetRecord({ ...params, page: pageParam }).then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
      cacheTime: 0,
    },
  );
};

export const useGetBetInquiryGames = ({ options }) => {
  return useQuery(
    [queryKey.BET_INQUIRY_GAMES],
    () =>
      apiGetGameList().then((res) => {
        const _result = [];
        res.data.data?.map((item) => {
          if (item.status === 1) {
            _result.push(item);
          }
        });
        // console.log('brand', _result)
        return _result;
      }),
    {
      ...options,
    },
  );
};

export const useGetBetInquirySubGames = ({ options }, gameCode) => {
  return useQuery(
    [queryKey.BET_INQUIRY_SUB_GAMES, gameCode],
    () =>
      apiGetSubGameList(gameCode).then((res) => {
        const setting = subGameListSetting[gameCode] ?? subGameListSetting.default;
        console.debug("SETTING", setting);
        const _result = [
          {
            value: "",
            label: "normal.all",
            is_translation: true,
          },
        ];
        res.data.data?.map((item) => {
          _result.push({
            value: item[setting.gameCodeApiKey],
            label: setting.isGameNameTranslate
              ? `${setting.translatePrefixKeyname}${item[setting.translateParamKey]}`
              : setting.nameRender
              ? setting.nameRender(item[setting.nameParamKey])
              : item[setting.nameParamKey],
            is_translation: setting.isGameNameTranslate,
          });
        });
        // console.log('brand', _result)
        return _result;
      }),
    {
      ...options,
    },
  );
};

// export const useGetAllBetInquirySubGames = ({ options }, gameList) => {
//   const _gameList = gameList?.filter((game) => hasSubGameListBrands.includes(game.game_3th_code)) || []
//   const _result = useQueries({
//     queries: _gameList?.map((game) => {
//       return {
//         queryKey: [queryKey.BET_INQUIRY_ALL_SUB_GAMES, game.game_3th_code],
//         queryFn: () => apiGetSubGameList(game.game_3th_code).then((res) => {
//           return { game_code: game.game_3th_code, data: res.data.data }
//         }),
//         ...options,
//       }
//     }),
//   })
//   const result = {}
//   console.log('_result', _result)
//   if (!!_result?.find((game) => game.fetchStatus === 'fetching')) {
//     console.log('hi')
//     return {};
//   } else {
//     _result?.map((game) => {
//       if (game.status === 'success') {
//         result[game?.data?.game_code] = game?.data?.data
//       }
//     })
//   }
//   // console.log('result', result)
//   return result;
// };
